export function homeProductlist_filedMirgrants(node) {
  // 列数  字段迁移
  if (node.data.attribute.listitem_value) {
    node.data.attribute.listV2_value = node.data.attribute.listitem_value
  }

  // 列间距  字段迁移
  if (node.data.design.listitem_colPadding) {
    node.data.design.listV2_gapValue = node.data.design.listitem_colPadding
  }
  if (node.data.design.listitem_colPaddingUnit) {
    node.data.design.listV2_gapUnit = node.data.design.listitem_colPaddingUnit
  }

  return node
}
